<template>
  <v-row no-gutters align="start" justify="start" class="editor-button-group mt-2">
    <v-col
      v-for="(opt, i) in options"
      :key="i"
      :cols="12 / options.length"
      class="px-1"
    >
      <v-btn
        :outlined="!isActive(opt)"
        :elevation="0"
        :color="color"
        class="editor-button-group__btn rounded-lg p-2"
        small
        :aria-label="opt.ariaLabel || opt.label"
        :aria-pressed="isActive(opt)"
        @click="$emit('select', opt.value)"
      >
        <slot name="option" :option="opt" :is-active="isActive(opt)">
          {{ opt.label }}
        </slot>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'EditorButtonGroup',
  props: {
    options: {
      type: Array,
      required: true
    },
    active: {
      type: [String, Number, Boolean],
      default: null
    },
    color: {
      type: String,
      default: '#9BA9BD'
    },
    activeColor: {
      type: String,
      default: null
    }
  },
  methods: {
    isActive(opt) {
      return this.active === opt.value
    }
  }
}
</script>

<style scoped>
.editor-button-group__btn {
  width: 100%;
  min-width: auto;
}
</style>
